module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "700px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.viewMode ? 'View' : 'Edit') + " Client Account")]), _vm._v(" "), _c('v-card-text', [_c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.panels),
      callback: function($$v) {
        _vm.panels = $$v
      },
      expression: "panels"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Contact Details")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [(_vm.needCompany) ? _c('v-select', {
    attrs: {
      "prepend-icon": "business",
      "label": "Assign a Company to client",
      "items": _vm.company_options,
      "item-text": "name",
      "item-value": "id",
      "readonly": _vm.viewMode
    },
    model: {
      value: (_vm.client.companyID),
      callback: function($$v) {
        _vm.$set(_vm.client, "companyID", $$v)
      },
      expression: "client.companyID"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "prepend-icon": "person_outline",
      "label": "Sales Representative",
      "items": _vm.salePerson_options,
      "readonly": _vm.viewMode,
      "item-text": "firstName",
      "item-value": "id"
    },
    model: {
      value: (_vm.client.salePerson),
      callback: function($$v) {
        _vm.$set(_vm.client, "salePerson", $$v)
      },
      expression: "client.salePerson"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "prepend-icon": "groups",
      "items": _vm.xeroContacts,
      "readonly": _vm.viewMode,
      "label": "Billing Name as per Xero",
      "item-text": "Name",
      "attach": "",
      "dense": "",
      "return-object": ""
    },
    on: {
      "change": _vm.changeClientGroup
    },
    model: {
      value: (_vm.client.group),
      callback: function($$v) {
        _vm.$set(_vm.client, "group", $$v)
      },
      expression: "client.group"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "business",
      "label": "Client Name (enter only if billing name as per xero cannot be found above)",
      "placeholder": "",
      "readonly": _vm.viewMode,
      "error-messages": _vm.nameErrors,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.client.name.$touch()
      },
      "blur": function($event) {
        return _vm.$v.client.name.$touch()
      }
    },
    model: {
      value: (_vm.client.name),
      callback: function($$v) {
        _vm.$set(_vm.client, "name", $$v)
      },
      expression: "client.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "phone",
      "label": "Primary Contact Number",
      "placeholder": "",
      "readonly": _vm.viewMode,
      "required": ""
    },
    model: {
      value: (_vm.client.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.client, "phoneNumber", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "client.phoneNumber"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "location_on",
      "label": "Address (to be included in invoice)",
      "placeholder": "Enter Contact Address",
      "readonly": _vm.viewMode,
      "error-messages": _vm.addressErrors,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.client.address.$touch()
      },
      "blur": function($event) {
        return _vm.$v.client.address.$touch()
      }
    },
    model: {
      value: (_vm.client.address),
      callback: function($$v) {
        _vm.$set(_vm.client, "address", $$v)
      },
      expression: "client.address"
    }
  })], 1), _vm._v(" "), _c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.contactPanels),
      callback: function($$v) {
        _vm.contactPanels = $$v
      },
      expression: "contactPanels"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n                        Contacts\n                      ")])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_vm._l((_vm.client.contacts), function(contact, index) {
    return _c('v-list', {
      key: index,
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-item', {
      staticClass: "justify-end",
      attrs: {
        "dense": ""
      }
    }, [_c('v-checkbox', {
      attrs: {
        "readonly": _vm.viewMode,
        "label": "Include in Email",
        "color": "secondary",
        "true-value": true,
        "false-value": false,
        "hide-details": "",
        "dense": ""
      },
      model: {
        value: (contact.includeEmail),
        callback: function($$v) {
          _vm.$set(contact, "includeEmail", $$v)
        },
        expression: "contact.includeEmail"
      }
    })], 1), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-text-field', {
      staticClass: "ma-0 pa-0",
      attrs: {
        "prepend-icon": "person",
        "label": "Contact Person",
        "placeholder": "",
        "readonly": _vm.viewMode,
        "required": ""
      },
      model: {
        value: (contact.contactName),
        callback: function($$v) {
          _vm.$set(contact, "contactName", $$v)
        },
        expression: "contact.contactName"
      }
    })], 1), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-text-field', {
      staticClass: "ma-0 pa-0",
      attrs: {
        "prepend-icon": "email",
        "label": "Contact Email",
        "placeholder": "",
        "readonly": _vm.viewMode
      },
      on: {
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
          $event.preventDefault();
        },
        "paste": _vm.preventPasteSpaces,
        "change": function($event) {
          return _vm.checkAccEmail(index)
        }
      },
      model: {
        value: (contact.email),
        callback: function($$v) {
          _vm.$set(contact, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "contact.email"
      }
    })], 1), _vm._v(" "), (contact.invalid) ? _c('v-list-item', {
      staticStyle: {
        "margin-top": "-15px"
      },
      attrs: {
        "dense": ""
      }
    }, [_c('p', {
      staticClass: "text-danger"
    }, [_vm._v("Email Already Exists.")])]) : _vm._e(), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-combobox', {
      staticClass: "ma-0 mb-3 pa-0",
      attrs: {
        "prepend-icon": "mdi-file-check",
        "readonly": _vm.viewMode,
        "items": _vm.campaigns,
        "item-text": "name",
        "item-value": "id",
        "outlined": "",
        "dense": "",
        "small-chips": "",
        "label": "Campaigns",
        "multiple": "",
        "hide-details": ""
      },
      model: {
        value: (contact.campaigns),
        callback: function($$v) {
          _vm.$set(contact, "campaigns", $$v)
        },
        expression: "contact.campaigns"
      }
    })], 1), _vm._v(" "), _c('v-list-item', {
      staticClass: "justify-end",
      attrs: {
        "dense": ""
      }
    }, [(!_vm.viewMode) ? _c('v-btn', {
      attrs: {
        "text": "",
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.removeContact(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-delete-forever")]), _vm._v("  Delete\n                        ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "ma-0 pa-0"
    })], 1)
  }), _vm._v(" "), (!_vm.viewMode) ? _c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.addDefaultContact()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add Contact\n                    ")], 1) : _vm._e()], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Account Details")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('div', [_c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountDeals.length > 0),
      expression: "accountDeals.length > 0"
    }],
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "text": "",
      "elevation": "0"
    }
  }, [_c('v-expansion-panels', _vm._l((_vm.accountDeals), function(item, index) {
    return _c('v-expansion-panel', {
      key: index
    }, [_c('v-expansion-panel-header', {
      staticStyle: {
        "text-transform": "capitalize"
      },
      attrs: {
        "disable-icon-rotate": ""
      }
    }, [_c('span', [_c('p', {
      staticClass: "pr-2 pb-2 mb-0"
    }, [_vm._v("\n                                  " + _vm._s(_vm.getProductName(item.name)) + "\n                                ")]), _vm._v(" "), (item.masterListCheck && !_vm.viewMode) ? _c('v-chip', {
      attrs: {
        "color": "green",
        "outlined": "",
        "x-small": "",
        "readonly": _vm.viewMode
      }
    }, [_vm._v("\n                                  Masterlist \n                                  "), _c('v-icon', {
      attrs: {
        "color": "success",
        "small": ""
      }
    }, [_vm._v("mdi-check")])], 1) : _vm._e(), _vm._v(" "), (!item.masterListCheck && !_vm.viewMode && _vm.isLinkMasterListBtn) ? _c('v-btn', {
      attrs: {
        "color": "warning",
        "x-small": ""
      },
      on: {
        "click": function($event) {
          return _vm.linkMasterlist(item)
        }
      }
    }, [_vm._v("\n                                  Link Masterlist\n                                ")]) : _vm._e()], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('v-row', {
      staticClass: "pa-0"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Deals Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.budget || '-'))])])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("IO")]), _vm._v(" "), _c('p', {
      staticClass: "mb-2"
    }, [_vm._v(_vm._s(item.IO || '-'))])])], 1)], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [(item.activationDate) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Activation Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.activationDate))])])], 1) : _vm._e(), _vm._v(" "), (item.linkedIOs && item.linkedIOs.length) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Linked IO")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.showLinkedIO(item.linkedIOs)))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Quote Acceptance Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(item.quoteAcceptanceDate)))])])], 1), _vm._v(" "), (item.markupCOGS) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Markup COGS Amount")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.cogsAmount || '-'))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [(item.vertical) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Campaign Vertical")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.displayCampaignVerticals(item.vertical)))])])], 1) : _vm._e(), _vm._v(" "), (item.country) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('p', _vm._l((item.country), function(item, index) {
      return _c('v-chip', {
        key: index,
        staticClass: "ma-1",
        attrs: {
          "small": ""
        }
      }, [_vm._v("\n                                          " + _vm._s(item.name) + "\n                                        ")])
    }), 1)])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Client Type")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getClientTypeDisplayValue(item.clientType)))])])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Line of Services")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.servicesLine))])])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.remarks || '-'))])])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-expansion-panels', _vm._l((item.products), function(product, pindex) {
      return _c('v-expansion-panel', {
        key: pindex
      }, [_c('v-expansion-panel-header', {
        staticStyle: {
          "text-transform": "capitalize"
        }
      }, [_vm._v(_vm._s(_vm.getProductName(product.name)))]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'storytell'),
          expression: "product.name.toLowerCase() === 'storytell'"
        }]
      }, [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-clipboard-list-outline")]), _vm._v(" No. of Campaigns: "), _c('strong', [_vm._v(_vm._s(product.noOfCampaigns))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-scatter-plot")]), _vm._v(" Total Outreach: "), _c('strong', [_vm._v(_vm._s(product.totalOutReach))])], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-chart-areaspline ")]), _vm._v(" Total Engagement: "), _c('strong', [_vm._v(_vm._s(product.totalEngagement))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.minContent))])], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.maxContent))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(product.createdDate)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'amplify'),
          expression: "product.name.toLowerCase() === 'amplify'"
        }]
      }, [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-file-eye-outline ")]), _vm._v(" Views: "), _c('strong', [_vm._v(_vm._s(product.views))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.minContent || 0))])], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.maxContent || product.noOfContents))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Duration: "), _c('strong', [_vm._v(_vm._s(product.duration) + " " + _vm._s((product.duration > 1 ? 'Months' : 'Month')))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(product.createdDate)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'uncut' || product.name.toLowerCase() === 'aok'),
          expression: "product.name.toLowerCase() === 'uncut' || product.name.toLowerCase() === 'aok'"
        }]
      }, [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-scatter-plot")]), _vm._v(" Total Outreach: "), _c('strong', [_vm._v(_vm._s(product.totalOutReach || '-'))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.minContent || 0))])], 1), _vm._v(" "), _c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "6",
          "lg": "6"
        }
      }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(product.maxContent || product.noOfContents))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12",
          "md": "12",
          "lg": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" KPI Onboarded: "), _c('strong', [_vm._v(_vm._s(product.kpiOnboarded || 0))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(product.createdDate)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'others'),
          expression: "product.name.toLowerCase() === 'others'"
        }]
      }, [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-bookmark")]), _vm._v(" Remark: "), _c('strong', [_vm._v(_vm._s(product.remark))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-file-outline")]), _vm._v(" Nature of Deal: "), _c('strong', [_vm._v(_vm._s(_vm.displayNatureOfDeals(product.natureOfDeal)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'loading fees'),
          expression: "product.name.toLowerCase() === 'loading fees'"
        }]
      }, [_c('v-row', [_c('v-col', {
        attrs: {
          "cols": "12",
          "sm": "12"
        }
      }, [_c('v-icon', [_vm._v("mdi-bookmark")]), _vm._v(" Remark: "), _c('strong', [_vm._v(_vm._s(product.remark))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.buttonShow('delete') && !_vm.viewMode) ? _c('v-btn', {
        attrs: {
          "text": "",
          "color": "error"
        },
        on: {
          "click": function($event) {
            return _vm.deleteProductsFromAccountDetails(index, pindex)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "left": ""
        }
      }, [_vm._v("mdi-delete-forever")]), _vm._v("  Delete\n                                            ")], 1) : _vm._e(), _vm._v(" "), (!_vm.buttonShow('delete') && !_vm.viewMode) ? _c('v-btn', {
        attrs: {
          "text": "",
          "color": "warning"
        },
        on: {
          "click": function($event) {
            return _vm.reqForDelete(index, pindex)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "left": ""
        }
      }, [_vm._v("mdi-delete-forever")]), _vm._v(" Request for Delete\n                                            ")], 1) : _vm._e()], 1)], 1)], 1)
    }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (!_vm.viewMode) ? _c('v-btn', {
      attrs: {
        "text": "",
        "color": "info"
      },
      on: {
        "click": function($event) {
          return _vm.dealsEdit(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-pencil")]), _vm._v(" Edit\n                                ")], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('delete') && !_vm.viewMode) ? _c('v-btn', {
      attrs: {
        "text": "",
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.deleteDeals(index, true)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-delete-forever")]), _vm._v("  Delete\n                                ")], 1) : _vm._e(), _vm._v(" "), (!_vm.buttonShow('delete') && !_vm.viewMode) ? _c('v-btn', {
      attrs: {
        "text": "",
        "color": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.reqForDelete(index, null)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-delete-forever")]), _vm._v("  Request for Delete\n                                ")], 1) : _vm._e()], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.viewMode) ? _c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.addDeals
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("\n                    mdi-plus\n                    ")]), _vm._v("\n                    Add Deals\n                  ")], 1) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Assigned Team")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('AssignTeam', {
    attrs: {
      "assignUsers": _vm.assignUsers,
      "dedicatedData": _vm.dedicatedData,
      "supportingData": _vm.supportingData,
      "viewMode": _vm.viewMode
    },
    on: {
      "updateSelectedDedicated": _vm.updateSelectedDedicated,
      "updateSelectedSupporting": _vm.updateSelectedSupporting
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Billing Details")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('v-checkbox', {
    attrs: {
      "label": "Billing information is same as contact information",
      "readonly": _vm.viewMode
    },
    model: {
      value: (_vm.sameWithContactInfo),
      callback: function($$v) {
        _vm.sameWithContactInfo = $$v
      },
      expression: "sameWithContactInfo"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "prepend-icon": "payment",
      "label": "Payment Mode",
      "items": _vm.clientPaymentModes,
      "item-text": "name",
      "item-value": "value",
      "readonly": _vm.viewMode
    },
    model: {
      value: (_vm.client.paymentMode),
      callback: function($$v) {
        _vm.$set(_vm.client, "paymentMode", $$v)
      },
      expression: "client.paymentMode"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "location_on",
      "label": "Billing Address",
      "placeholder": "Enter Billing Address",
      "disabled": _vm.sameWithContactInfo || _vm.viewMode
    },
    model: {
      value: (_vm.client.billingAddress),
      callback: function($$v) {
        _vm.$set(_vm.client, "billingAddress", $$v)
      },
      expression: "client.billingAddress"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "phone",
      "label": "Billing Contact",
      "placeholder": "Enter billing contact number",
      "disabled": _vm.sameWithContactInfo || _vm.viewMode
    },
    model: {
      value: (_vm.client.billingPhoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.client, "billingPhoneNumber", $$v)
      },
      expression: "client.billingPhoneNumber"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "email",
      "label": "Billing Email",
      "placeholder": "Enter billing email",
      "disabled": _vm.sameWithContactInfo || _vm.viewMode,
      "error-messages": _vm.emailErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.client.email.$touch()
      },
      "blur": function($event) {
        return _vm.$v.client.email.$touch()
      }
    },
    model: {
      value: (_vm.client.billingEmail),
      callback: function($$v) {
        _vm.$set(_vm.client, "billingEmail", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "client.billingEmail"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.viewMode) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeEditModal
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.editClient
    }
  }, [_vm._v("Save")])], 1) : _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.directCloseModal
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n          Please stand by\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.addDealsDialog),
      callback: function($$v) {
        _vm.addDealsDialog = $$v
      },
      expression: "addDealsDialog"
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-width": "350px"
    }
  }, [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Add New Deals")])]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "dealForm"
  }, [_c('v-container', [_c('v-autocomplete', {
    staticClass: "mt-5",
    attrs: {
      "items": _vm.displayMasterLists,
      "item-text": "quoteNo",
      "item-value": "quoteNo",
      "label": "IO Number",
      "prepend-icon": "mdi-file-outline",
      "prefix": "IO-",
      "dense": "",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    on: {
      "change": _vm.changeIONumber
    },
    model: {
      value: (_vm.client.deals.IO),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "IO", $$v)
      },
      expression: "client.deals.IO"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('label', [_vm._v("Linked IO")]), _c('br'), _vm._v(" "), _vm._l((_vm.client.deals.linkedIOs), function(linkIO, index) {
    return _c('div', {
      key: index,
      staticClass: "d-flex flex-row mb-2"
    }, [_c('v-text-field', _vm._g({
      attrs: {
        "prefix": "IO-",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      on: {
        "change": _vm.changeLinkedIO
      },
      model: {
        value: (_vm.client.deals.linkedIOs[index]),
        callback: function($$v) {
          _vm.$set(_vm.client.deals.linkedIOs, index, $$v)
        },
        expression: "client.deals.linkedIOs[index]"
      }
    }, _vm.on)), _vm._v(" "), _c('v-btn', {
      staticStyle: {
        "min-width": "30px",
        "height": "36px",
        "margin-left": "5px"
      },
      attrs: {
        "color": "red",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteLinkIO(index)
        }
      }
    }, [_c('v-icon', {
      staticStyle: {
        "color": "#fff"
      },
      attrs: {
        "x-small": ""
      }
    }, [_vm._v("mdi-delete-outline")])], 1)], 1)
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2 ml-0",
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.addLinkIO()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "title": "Add Invoice Sent",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add\n              ")], 1)], 2), _vm._v(" "), _c('v-menu', {
    ref: "pickDate",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          staticClass: "pt-3",
          attrs: {
            "label": "Quote Acceptance Date *",
            "prepend-icon": "event",
            "dense": "",
            "readonly": "",
            "disabled": "",
            "rules": [_vm.rules.required]
          },
          model: {
            value: (_vm.client.deals.quoteAcceptanceDate),
            callback: function($$v) {
              _vm.$set(_vm.client.deals, "quoteAcceptanceDate", $$v)
            },
            expression: "client.deals.quoteAcceptanceDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.pickDate),
      callback: function($$v) {
        _vm.pickDate = $$v
      },
      expression: "pickDate"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function($event) {
        _vm.pickDate = false
      }
    },
    model: {
      value: (_vm.client.deals.quoteAcceptanceDate),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "quoteAcceptanceDate", $$v)
      },
      expression: "client.deals.quoteAcceptanceDate"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "prepend-icon": "attach_money",
      "label": "Budget",
      "placeholder": "Enter budget",
      "disabled": ""
    },
    model: {
      value: (_vm.client.deals.previewBudget),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "previewBudget", _vm._n($$v))
      },
      expression: "client.deals.previewBudget"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "prepend-icon": "attach_money",
      "label": "Total Budget",
      "placeholder": "Enter Total Budget",
      "rules": [_vm.rules.required],
      "disabled": ""
    },
    model: {
      value: (_vm.client.deals.budget),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "budget", _vm._n($$v))
      },
      expression: "client.deals.budget"
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "text",
      "prepend-icon": "mdi-file-outline",
      "label": "Deal Name *",
      "placeholder": "Enter Deal Name",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.client.deals.name),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "name", $$v)
      },
      expression: "client.deals.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Activation Date",
      "prepend-icon": "mdi-file-outline",
      "dense": "",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    on: {
      "input": function($event) {
        return _vm.checkDate('activationDate')
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkDate('activationDate')
      }
    },
    model: {
      value: (_vm.client.deals.activationDate),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "activationDate", $$v)
      },
      expression: "client.deals.activationDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "date-picker-inner"
  }, [_c('date-picker', {
    attrs: {
      "className": "input-field",
      "options": {
        theme: 'icon'
      },
      "status": _vm.actDateCal
    },
    on: {
      "changeDate": function($event) {
        var i = arguments.length, argsArray = Array(i);
        while ( i-- ) argsArray[i] = arguments[i];

        return _vm.setDateFromPicker.apply(void 0, [ 'activationDate' ].concat( argsArray ))
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-combobox', {
    staticClass: "mt-5 pt-2",
    attrs: {
      "items": _vm.campaignVerticals,
      "item-text": "name",
      "item-value": "name",
      "prepend-icon": "mdi-file-outline",
      "hide-selected": "",
      "dense": "",
      "label": "Campaign Vertical",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var attrs = ref.attrs;
        var item = ref.item;
        var parent = ref.parent;
        var selected = ref.selected;

        return [(item === Object(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                    $delete\n                  ")])], 1) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.client.deals.vertical),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "vertical", $$v)
      },
      expression: "client.deals.vertical"
    }
  }), _vm._v(" "), _c('v-combobox', {
    staticClass: "mt-5",
    attrs: {
      "prepend-icon": "mdi-file-outline",
      "items": _vm.countries,
      "item-text": "name",
      "item-value": "code",
      "hide-selected": "",
      "multiple": "",
      "chips": "",
      "label": "Country",
      "dense": "",
      "rules": [_vm.rules.required]
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var attrs = ref.attrs;
        var item = ref.item;
        var parent = ref.parent;
        var selected = ref.selected;

        return [(item === Object(item)) ? _c('v-chip', _vm._b({
          attrs: {
            "input-value": selected,
            "label": "",
            "small": ""
          }
        }, 'v-chip', attrs, false), [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return parent.selectItem(item)
            }
          }
        }, [_vm._v("\n                    $delete\n                  ")])], 1) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.client.deals.country),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "country", $$v)
      },
      expression: "client.deals.country"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "mt-5 pt-2",
    attrs: {
      "items": _vm.clientTypes,
      "item-text": "title",
      "item-value": "value",
      "label": "Client Type",
      "prepend-icon": "mdi-file-outline",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.client.deals.clientType),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "clientType", $$v)
      },
      expression: "client.deals.clientType"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "mt-5 pt-2",
    attrs: {
      "items": _vm.lineOfServices,
      "label": "Line of Services",
      "prepend-icon": "mdi-file-outline",
      "dense": "",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.client.deals.servicesLine),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "servicesLine", $$v)
      },
      expression: "client.deals.servicesLine"
    }
  }), _vm._v(" "), _c('v-textarea', {
    staticClass: "mt-5 pt-2",
    attrs: {
      "filled": "",
      "label": "Remarks",
      "prepend-icon": "mdi-bookmark-check-outline"
    },
    model: {
      value: (_vm.client.deals.remarks),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "remarks", $$v)
      },
      expression: "client.deals.remarks"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "",
      "label": "this is a mark-up deal (special approval has been obtained prior)",
      "small": ""
    },
    on: {
      "change": _vm.changeMarkupCOGS
    },
    model: {
      value: (_vm.client.deals.markupCOGS),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "markupCOGS", $$v)
      },
      expression: "client.deals.markupCOGS"
    }
  }), _vm._v(" "), (_vm.client.deals.markupCOGS) ? _c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "COGS Amount",
      "placeholder": "Enter COGS Amount",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.client.deals.cogsAmount),
      callback: function($$v) {
        _vm.$set(_vm.client.deals, "cogsAmount", $$v)
      },
      expression: "client.deals.cogsAmount"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ma-2 white--text",
          attrs: {
            "color": "info"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": "",
            "dark": ""
          }
        }, [_vm._v("\n              mdi-plus\n              ")]), _vm._v("\n              Add Products\n            ")], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        return _vm.addProducts('Storytell')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Storytell")])], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        return _vm.addProducts('Amplify')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Amplify")])], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        return _vm.addProducts('aok')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("AOK/Uncut")])], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        return _vm.addProducts('Loading Fees')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Loading Fees")])], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function($event) {
        return _vm.addProducts('Others')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Others")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountProducts.length > 0),
      expression: "accountProducts.length > 0"
    }]
  }), _vm._v(" "), _c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountProducts.length > 0),
      expression: "accountProducts.length > 0"
    }],
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "text": "",
      "elevation": "0"
    }
  }, [_c('v-expansion-panels', _vm._l((_vm.accountProducts), function(item, index) {
    return _c('v-expansion-panel', {
      key: index
    }, [_c('v-expansion-panel-header', {
      staticStyle: {
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.getProductName(item.name)))]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'storytell'),
        expression: "item.name.toLowerCase() === 'storytell'"
      }]
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-clipboard-list-outline")]), _vm._v(" No. of Campaigns: "), _c('strong', [_vm._v(_vm._s(item.noOfCampaigns))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-scatter-plot")]), _vm._v(" Total Outreach: "), _c('strong', [_vm._v(_vm._s(item.totalOutReach))])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-chart-areaspline ")]), _vm._v(" Total Engagement: "), _c('strong', [_vm._v(_vm._s(item.totalEngagement))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.minContent))])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.maxContent))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(item.createdDate)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'amplify'),
        expression: "item.name.toLowerCase() === 'amplify'"
      }]
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-file-eye-outline ")]), _vm._v(" Views: "), _c('strong', [_vm._v(_vm._s(item.views))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.minContent || 0))])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.maxContent || item.noOfContents))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Duration: "), _c('strong', [_vm._v(_vm._s(item.duration) + " Months")])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(item.createdDate)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'uncut' || item.name.toLowerCase() === 'aok'),
        expression: "item.name.toLowerCase() === 'uncut'  || item.name.toLowerCase() === 'aok'"
      }]
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-scatter-plot")]), _vm._v(" Total Outreach: "), _c('strong', [_vm._v(_vm._s(item.totalOutReach || '-'))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" Min. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.minContent || 0))])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-icon', [_vm._v("mdi-sort-variant")]), _vm._v(" Max. Original Contents: "), _c('strong', [_vm._v(_vm._s(item.maxContent || item.noOfContents))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-text")]), _vm._v(" KPI Onboarded: "), _c('strong', [_vm._v(_vm._s(item.kpiOnboarded || 0))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(" Created Date: "), _c('strong', [_vm._v(_vm._s(_vm.formattedDate(item.createdDate)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'others'),
        expression: "item.name.toLowerCase() === 'others'"
      }]
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-bookmark-check-outline")]), _vm._v(" Remark: "), _c('strong', [_vm._v(_vm._s(item.remark))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-file-outline")]), _vm._v(" Nature of deal: "), _c('strong', [_vm._v(_vm._s(_vm.displayNatureOfDeals(item.natureOfDeal)))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'loading fees'),
        expression: "item.name.toLowerCase() === 'loading fees'"
      }]
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-icon', [_vm._v("mdi-bookmark-check-outline")]), _vm._v(" Remark: "), _c('strong', [_vm._v(_vm._s(item.remark))])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "color": "info"
      },
      on: {
        "click": function($event) {
          return _vm.productEdit(item, index)
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-pencil")]), _vm._v(" Edit\n                      ")], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "id": "deleteDealsProduct",
        "text": "",
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.deleteProducts(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-delete-forever")]), _vm._v("  Delete\n                      ")], 1)], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": _vm.closeDealsModal
    }
  }, [_vm._v("\n            Close\n          ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "info",
    on: {
      "click": _vm.addEditDeals
    }
  }, [_vm._v("\n            " + _vm._s((this.dealAction === 'add' ? 'Add' : 'Save')) + "\n          ")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.addEditDialog),
      callback: function($$v) {
        _vm.addEditDialog = $$v
      },
      expression: "addEditDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline",
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.showProductName))])]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form"
  }, [_c('v-container', [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() === 'amplify' && _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() === 'amplify' && productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "mdi-file-eye-outline",
      "label": "Views",
      "placeholder": "Enter views"
    },
    model: {
      value: (_vm.client.moreAccount.views),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "views", _vm._n($$v))
      },
      expression: "client.moreAccount.views"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() === 'amplify' && _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() === 'amplify' && productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "mdi-calendar",
      "label": "Duration",
      "placeholder": "Enter No. of months"
    },
    model: {
      value: (_vm.client.moreAccount.duration),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "duration", _vm._n($$v))
      },
      expression: "client.moreAccount.duration"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() !== 'amplify' && _vm.productName.toLowerCase() !== 'others' && _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() !== 'amplify' && productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "scatter_plot",
      "label": "Total Outreach",
      "placeholder": "Enter total outreach"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.totalOutReach),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "totalOutReach", _vm._n($$v))
      },
      expression: "client.moreAccount.totalOutReach"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() !== 'amplify' &&
        _vm.productName.toLowerCase() !== 'uncut' &&
        _vm.productName.toLowerCase() !== 'aok' &&
        _vm.productName.toLowerCase() !== 'others' &&
        _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() !== 'amplify' &&\n                  productName.toLowerCase() !== 'uncut' &&\n                  productName.toLowerCase() !== 'aok' &&\n                  productName.toLowerCase() !== 'others' &&\n                  productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "score",
      "label": "Total Engagement",
      "placeholder": "Enter total engagement"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.totalEngagement),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "totalEngagement", _vm._n($$v))
      },
      expression: "client.moreAccount.totalEngagement"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() !== 'others' && _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "notes",
      "label": "Min. original content",
      "placeholder": "Enter minimum numbers of content"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.minContent),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "minContent", _vm._n($$v))
      },
      expression: "client.moreAccount.minContent"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() !== 'others' && _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "sort",
      "label": "Max. original content",
      "placeholder": "Enter maximum numbers of content"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.maxContent),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "maxContent", _vm._n($$v))
      },
      expression: "client.moreAccount.maxContent"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() === 'uncut' || _vm.productName.toLowerCase() === 'aok'),
      expression: "productName.toLowerCase() === 'uncut' || productName.toLowerCase() === 'aok'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "sort",
      "label": "KPI Onboarded",
      "placeholder": "Enter KPI Onboarded"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.kpiOnboarded),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "kpiOnboarded", _vm._n($$v))
      },
      expression: "client.moreAccount.kpiOnboarded"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() !== 'amplify' && _vm.productName.toLowerCase() !== 'uncut' && _vm.productName.toLowerCase() !== 'aok' && _vm.productName.toLowerCase() !== 'others' && _vm.productName.toLowerCase() !== 'loading fees'),
      expression: "productName.toLowerCase() !== 'amplify' && productName.toLowerCase() !== 'uncut' && productName.toLowerCase() !== 'aok' && productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
    }],
    attrs: {
      "type": "number",
      "prepend-icon": "list_alt",
      "label": "No. of Campaigns",
      "placeholder": "Enter numbers of campaigns"
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.client.moreAccount.maxCampaigns),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "maxCampaigns", _vm._n($$v))
      },
      expression: "client.moreAccount.maxCampaigns"
    }
  }), _vm._v(" "), _c('v-textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() === 'others' || _vm.productName.toLowerCase() === 'loading fees'),
      expression: "productName.toLowerCase() === 'others' || productName.toLowerCase() === 'loading fees'"
    }],
    attrs: {
      "filled": "",
      "label": "Remark",
      "placeholder": "Remark",
      "prepend-icon": "mdi-bookmark-check-outline"
    },
    model: {
      value: (_vm.client.moreAccount.remark),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "remark", $$v)
      },
      expression: "client.moreAccount.remark"
    }
  }), _vm._v(" "), _c('v-combobox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productName.toLowerCase() === 'others'),
      expression: "productName.toLowerCase() === 'others'"
    }],
    attrs: {
      "prepend-icon": "mdi-file-outline",
      "label": "Nature of deal",
      "search-input": _vm.newDealNature,
      "items": _vm.dealNatureLists,
      "item-text": "name",
      "item-value": "id",
      "chips": "",
      "multiple": "",
      "hide-selected": "",
      "clearable": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.newDealNature = $event
      },
      "update:search-input": function($event) {
        _vm.newDealNature = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function() {
        return [_c('v-list-item', [_c('span', {
          staticClass: "subheading pr-2"
        }, [_vm._v("Press Enter to Create")]), _vm._v(" "), _c('v-chip', {
          attrs: {
            "label": "",
            "small": ""
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.newDealNature) + "\n                      ")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.client.moreAccount.natureOfDeal),
      callback: function($$v) {
        _vm.$set(_vm.client.moreAccount, "natureOfDeal", $$v)
      },
      expression: "client.moreAccount.natureOfDeal"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": ""
    },
    on: {
      "click": _vm.closeAddEditProductsModal
    }
  }, [_vm._v("\n          Close\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.addEditProduct
    }
  }, [_vm._v("\n          " + _vm._s((this.productAction === 'add' ? 'Add' : 'Save')) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-682e6752"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Client/EditClientModal.vue
// module id = 2168
// module chunks = 0